.searchInput {
  width: 338px;
}
